export default __webpack_public_path__ + "static/media/Slice 2.5da61949.svg";